export enum Languages {
  ru = 'Русский',
  en = 'English',
  be = 'Беларускі',
}

export const DEFAULT_LANG = Languages.en;
export const DEFAULT_LANG_GAME = 'en';
